var _path, _ellipse, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14.611 14.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8a8d91",
    d: "M7.306,0a7.306,7.306,0,1,0,7.306,7.306A7.314,7.314,0,0,0,7.306,0Zm0,13.449Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#fff",
    cx: 0.838,
    cy: 0.838,
    rx: 0.838,
    ry: 0.838,
    transform: "translate(6.545 3.641)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.638,28.342a.5.5,0,0,0-.5.5V33.1a.5.5,0,0,0,1,0v-4.26A.5.5,0,0,0,30.638,28.342Z",
    transform: "translate(-23.336 -21.657)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4c14e9654408e9f0b4c30cc3d2cec6c8.svg";
export { ForwardRef as ReactComponent };